<ng-container
  *ngIf="showChart">
  <ng-container
    *transloco="let t; read: 'calculator_result.charts.peak-power'">
    <psc-section-title
      [title]="t('title')"
      alignment="left"
      size="normal"
      [lineWidthPercentage]="100"
      [lineThickness]="2"></psc-section-title>
    <div class="w-[100%] mb-10 flex justify-center">
      <canvas baseChart class="chart limited-max-height"
              [data]="peakPowerChartData"
              [height]="resultChartsService.regularChartHeight"
              [options]="peakPowerChartOptions"
              type="bar"></canvas>
    </div>

    <div class="-ml-[5000px] absolute">
      <canvas baseChart class="chart limited-max-height"
              [width]="resultChartsService.chartWidth"
              [height]="resultChartsService.chartForPdfHeight"
              [data]="peakPowerChartData"
              [options]="peakPowerChartOptions"
              type="bar"></canvas>
    </div>
  </ng-container>
</ng-container>
